import { Hint } from '@routable/components';
import { Time } from '@carbon/icons-react';
import {} from '@routable/taxes';
import React from 'react';
export const PendingTaxDocumentHint = ({ vendorName, vendorTaxFormType }) => {
    return (React.createElement(Hint, { icon: React.createElement(Time, null), title: `Waiting for ${vendorName} to submit their ${vendorTaxFormType}`, type: "info", variant: "outline" },
        React.createElement("span", null, `A ${vendorTaxFormType} is required to validate this vendor.`)));
};
